import { Component, effect, Input, OnInit } from '@angular/core';
import { NativeMarket } from '@capgo/native-market';
import { Platform } from '@ionic/angular';
import { GeneralService } from 'src/app/services/general.service';
import { StateService } from 'src/app/services/state.service';

@Component({
  selector: 'app-inappupdate',
  templateUrl: './inappupdate.page.html',
  styleUrls: ['./inappupdate.page.scss'],
})
export class InappupdatePage {

  @Input() currentVersion = ''
  @Input() latestVersion = ''
  percentage = 0

  constructor(
    protected platform: Platform,
    private stateService: StateService,
    private generalService: GeneralService
  ) { 

    effect(() => {
      this.percentage = this.stateService.updatePercentage      
    })

    console.log(123)
  }


  retryUpdate() {
    this.generalService.checkForUpdate()
    this.stateService.setUpdatePercentage(0)
  }
}
